import React from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import { pushNotification } from "utils/notifications";

class ThemMoiKho extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      StoreName: "",
      StoreAddress: "",
      StoreStatus: 1,
      StoreId: 0,
      errors: {
        StoreName: null,
      },
    };
    this.StoreName = React.createRef();
  }
  static getDerivedStateFromProps(props, state) {
    let { data } = props;
    if (data && data.StoreId && data.StoreId !== state.StoreId)
      return { ...data };
  }
  onChangeData = (field) => (event) => {
    let state = this.state;
    state[field] = event.target.value;
    this.setState(state);
  };
  onSumit = () => {
    let { StoreName, errors } = this.state;
    if (StoreName === "") {
      errors.StoreName = {
        message: "Hãy nhập tên kho",
      };
      this.StoreName.current.focus();
      this.setState({ errors });
      return;
    } else {
      errors.StoreName = null;
      this.setState({ errors });
    }
    let { postDataStore } = this.props;
    postDataStore(this.state);
  };
  render() {
    let { show, onHide } = this.props;
    let { StoreName, StoreAddress, StoreStatus, StoreId, errors } = this.state;

    return (
      <Modal
        show={show}
        size="modal-new-size modal-new-size"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <Modal.Header>
          <h4 className="modal-title  color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              <img src="/app-assets/images/icon-them-moi-hop-dong-v2.png" />
            </span>{" "}
            {StoreId > 0 ? "Cập nhật" : "Thêm mới"}
          </h4>
          <button
            type="button"
            className="close-popup-new"
            data-dismiss="modal"
            aria-label="Close"
            onClick={onHide}
          >
            <img src="/app-assets/images/icon-dong-popup-v2.png" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <form className="form tat-toan form-horizontal form-edit">
            <div className="form-body">
              <div className="card collapse-icon accordion-icon-rotate">
                <div
                  id="headingCollapse196"
                  className="card-header"
                  href="#collapse196"
                  aria-expanded="true"
                  aria-controls="collapse196"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Thêm mới kho</h3>
                  </a>
                </div>
                <div
                  id="collapse196"
                  aria-labelledby="headingCollapse96"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control color7-bold"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Tên kho"
                                starRed="*"
                                value={StoreName}
                                inputProps={{
                                  onChange: this.onChangeData("StoreName"),
                                  ref: this.StoreName,
                                }}
                                error={errors.StoreName}
                              ></TextInputOnRow>
                            </div>

                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control color7-bold"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Địa chỉ"
                                starRed="*"
                                value={StoreAddress}
                                inputProps={{
                                  onChange: this.onChangeData("StoreAddress"),
                                }}
                              ></TextInputOnRow>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="color7-bold">
                                  Trạng thái
                                </label>
                                <select
                                  className="form-control input-sm"
                                  value={StoreStatus}
                                  onChange={this.onChangeData("StoreStatus")}
                                >
                                  <option value="1">Còn chỗ</option>
                                  <option value="0">Hết chỗ</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <button
            type="button"
            class="btn btn-new-main btn-closenew"
            onClick={onHide}
          >
            <span>
              <i class="mdi mdi-close"></i>
            </span>
            &nbsp; Đóng
          </button>
          <button
            type="submit"
            className="btn btn-new-main btn-checknew"
            href={() => false}
            onClick={this.onSumit}
          >
            <span>
              <img src="/app-assets/images/icon-save-v2-white.png" />
            </span>
            &nbsp; {StoreId > 0 ? "Lưu" : "Thêm mới"} &nbsp;
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ThemMoiKho;
